import { render, staticRenderFns } from "./gwwtDialog.vue?vue&type=template&id=53573239&scoped=true&"
import script from "./gwwtDialog.vue?vue&type=script&lang=js&"
export * from "./gwwtDialog.vue?vue&type=script&lang=js&"
import style0 from "./gwwtDialog.vue?vue&type=style&index=0&id=53573239&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53573239",
  null
  
)

export default component.exports